(function($) {

	'use strict';

	var init = function() {
    var button = $('.flex-accordion__switchPanel')

    button.on('click', toggleTab)
  };
  
  var toggleTab = function() {
    var tab = $('#' + $(this).data('switch'))
    if($(this).hasClass('active')) {
      $(this).removeClass('active')
      tab.slideUp(300)
    } else {
      $('.flex-accordion__switchPanel').removeClass('active')
      $('.flex-accordion__tab').slideUp(300)
      $(this).toggleClass('active')
      tab.slideToggle(300)
    }
  }
  
	$(document).ready(function() {
		init(); 
	});

})(jQuery);
